import styled from 'styled-components';

export const StyledVisitTemplateReadOnly = styled.div`
   display: flex;
   flex-direction: column;
   gap: 15px;
   height: 100%;
`;
StyledVisitTemplateReadOnly.displayName = 'StyledVisitTemplateReadOnly';
